import apiHeader from '@/helpers/apiHeader';

const euMaterialService = {
    list(params) {
        return apiHeader.get('general-master-data/eu-materials', { params });
    },
};

export default euMaterialService;
